module.exports = __webpack_public_path__ + "img/badge-wc-fill.552424b7.svg";